var _circle, _mask, _g, _path, _mask2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#FDDF6A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#D4B076"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 14,
    height: 29.037,
    fill: "#F9CE23"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 21.0964L8.33824 23.1448C7.67224 23.3857 6.97373 22.877 6.99864 22.1692L7.20903 16.1929L3.5084 11.4862C3.06895 10.9272 3.33673 10.1012 4.02051 9.90636L9.80295 8.25891L13.1725 3.29343C13.5693 2.70879 14.4307 2.70879 14.8275 3.29343L18.197 8.25891L23.9795 9.90636C24.6633 10.1012 24.931 10.9272 24.4916 11.4862L20.791 16.1929L21.0014 22.1692C21.0263 22.877 20.3278 23.3857 19.6618 23.1448L14 21.0964Z",
    fill: "#FDEA9E"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 22,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 21.0964L8.33824 23.1448C7.67224 23.3857 6.97373 22.877 6.99864 22.1692L7.20903 16.1929L3.5084 11.4862C3.06895 10.9272 3.33673 10.1012 4.02051 9.90636L9.80295 8.25891L13.1725 3.29343C13.5693 2.70879 14.4307 2.70879 14.8275 3.29343L18.197 8.25891L23.9795 9.90636C24.6633 10.1012 24.931 10.9272 24.4916 11.4862L20.791 16.1929L21.0014 22.1692C21.0263 22.877 20.3278 23.3857 19.6618 23.1448L14 21.0964Z",
    fill: "#F2CB8D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 14,
    height: 29.037,
    fill: "#FFE26E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/Gold.a826e47b58672b26c54bb80429f94039.svg";
export { ForwardRef as ReactComponent };